import interceptorAxios from './InterceptorAxios';

const ServicioEmergencia={
    
  obtner_comprobante(objeto){
      return interceptorAxios.post('/emergencia/optener_comprobante.json',objeto);
  },
  buscar_plaza_folio_total(objeto){
    return interceptorAxios.post('/emergencia/buscar_concepto_emergencia.json',objeto);
  },
  realizar_calculos_cantidad_total(objeto){
    return interceptorAxios.post('/emergencia/realizar_calculos_cantidad_total.json',objeto)
  },
  plazas_asignadas_emisor(){
    return interceptorAxios.post('/emergencia/buscar_plaza_cobro_usuario.json');
  },
  eliminar_concepto(objeto){
    return interceptorAxios.post("/emergencia/eliminar_concepto.json",objeto);
  },
  facturacion_emergencia(objeto){
    return interceptorAxios.post("/emergencia/facturacion_emergencia.json",objeto);
  }
}
export default ServicioEmergencia;